var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.distance > 5000)?_c('v-alert',{attrs:{"color":"warning","dark":""}},[_vm._v("You are "+_vm._s(_vm._f("readableDistance")(_vm.distance,_vm.unit))+" from this location. Please make sure you are ordering from the right location.")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }